module.exports = __webpack_public_path__ + "static/media/upgrade_premium_bg.394ea345.jpg";